import React, { useState, useEffect, useContext } from 'react';
import { formatISO9075 } from 'date-fns';
import { Link } from 'react-router-dom';
import {
  Card, CardActionArea, CardMedia, CardContent, Typography, Box, IconButton, Button
} from '@mui/material';
import FavoriteIcon from '@mui/icons-material/Favorite';
import VisibilityIcon from '@mui/icons-material/Visibility';
import { BiCommentDetail } from "react-icons/bi";
import Tooltip from '@mui/material/Tooltip';
import { useDBPosts } from '../contexts/DBPostsContext';
import AuthModal from "../components/AuthModal";
import { UserContext } from '../contexts/UserContext';

export default function FavPosts({postInfo, onToggleFavorite }) {
    const [isPostFavorite, setIsPostFavorite] = useState(false);
    const [likesCount, setLikesCount] = useState(0);
    const [isLoading, setIsLoading] = useState(false); // New loading state
    const { userInfo, profileLoading } = useContext(UserContext); // Get userInfo and profileLoading
 // Ensure userInfo is available and has loaded before setting favorite status
 useEffect(() => {
    if (!profileLoading && postInfo && Array.isArray(postInfo.favoritedBy) && userInfo?.id) {
      const isFavorited = postInfo.favoritedBy.some(favUser => favUser._id === userInfo.id ||favUser === userInfo.id );
      setIsPostFavorite(isFavorited);
      setLikesCount(postInfo.favoritedBy.length);
      
    }
   
  }, [postInfo, userInfo, profileLoading]);
  
    const handleFavoriteClick = async () => {
      if (isLoading) return; // Prevent multiple clicks during loading
      setIsLoading(true); // Start loading
  
      // Optimistic UI update: Update the favorite state and likes count before the API call
      const wasFavorite = isPostFavorite; // Save the previous favorite state to revert on error
      const previousLikesCount = likesCount; // Save the previous likes count to revert on error
      const newLikesCount = isPostFavorite ? likesCount - 1 : likesCount + 1;
  
      setIsPostFavorite(!isPostFavorite); // Toggle favorite optimistically
      setLikesCount(newLikesCount); // Update likes count optimistically
  
      try {
        // Call the parent toggleFavorite function to update on the server
        const result = await onToggleFavorite(postInfo);
  
        // Ensure the operation was successful and contains updatedPost
        if (result && result.success && result.updatedPost) {
          const updatedPost = result.updatedPost;
  
          // Update likes count based on the updatedPost
          setLikesCount(updatedPost.favoritedBy.length);
  
          // Check if the userInfo contains the post as favorite in updatedPost
          const isFavoriteInUpdatedPost = updatedPost.favoritedBy.some(userId => userId === userInfo?.id);
  
          // Only update isPostFavorite if the new server response contradicts the optimistic change
          if (isFavoriteInUpdatedPost !== isPostFavorite) {
            setIsPostFavorite(isFavoriteInUpdatedPost);
          }
  
          console.log('Updated post favorite status:', updatedPost);
        } else {
          throw new Error("Failed to toggle favorite: Post update was not successful.");
        }
      } catch (error) {
        console.error('Error toggling favorite:', error);
        // Revert the optimistic update if the API call fails
        setIsPostFavorite(wasFavorite);
        setLikesCount(previousLikesCount);
      } finally {
        setIsLoading(false); // End loading
      }
    };
  return (
    <div>
          <Box key={postInfo._id} sx={{ minWidth: 200, mr: 2 }}>
        

        <Box 
  sx={{ 
    maxWidth: 200, 
    position: 'relative', 
    overflow: 'hidden',  // Prevents image from growing outside the container
  }}
> 
  {/* Image Container */}
  <img
    component="img"
    style={{ width: '100%', borderRadius: '7px' }}  // Ensures the image takes the full width of the container
    src={postInfo.cover}
    alt={postInfo.title}
    className="img-hover"  // Adds hover effect to the image
  />

  {/* Likes and Favorite Icon Box */}
  <Box
    sx={{
      position: 'absolute',
      bottom: 0,
      right: 0,
      backgroundColor: 'white',
      paddingX: '12px',         // Adjusted padding for better layout
      paddingY: '5px',
      display: 'flex',
      alignItems: 'center',
      borderTopLeftRadius: '30px',  // Circular left border
      borderBottomLeftRadius: '30px',  // Circular left border
      borderTopRightRadius: '0px',  // Square right border
      borderBottomRightRadius: '0px',  // Square right border
      boxShadow: '0px 2px 4px rgba(0, 0, 0, 0.2)',  // Optional shadow for better visibility
    }}
  >

  {/* add like / unlike when user toggle this btn  */}
    <IconButton
      onClick={handleFavoriteClick}
      sx={{ color: 'black' }}  // Changed to black for better contrast with white background
      className={isPostFavorite ? 'post-icon-active' : 'post-icon'}
    >
      <FavoriteIcon />
    </IconButton>
    <Typography variant="body2" color="black">
      {postInfo?.favoritedBy?.length}
    </Typography>
  </Box>
</Box>


<Box sx={{ maxWidth: 200, position: 'relative', my:2 }}> {/* Adjusted maxWidth to match image width */}
<Typography variant="body1" color="black">
      {postInfo.title}
    </Typography>

    </Box>


          </Box>
    </div>
  )
}
